module.exports = __webpack_public_path__ + "static/media/mg.c498bdeb.png";